export default class Factory {
  constructor() {
    this.id = ''
    this.title = ''
    this.created = ''
    this.modified = ''
  }
}
